import React from "react";
import Box from "components/common/Box";
import Stack from "components/common/Stack";
import Text from "components/common/Text";

/**
 * Figma 8068:148725 — "Contact Service Mini" (primary card with CTA)
 */
const ContactServiceCard = ({ onContactClick }) => (
  <Box
    sx={{
      bgcolor: "#fff",
      border: "1px solid #E2E8F0",
      borderRadius: "20px",
      p: 2.5,
    }}
  >
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Text sx={{ fontWeight: 700, fontSize: "16px", color: "#111827" }}>
        Contact Service
      </Text>

      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Box
          sx={{
            bgcolor: "#F8FAFC",
            borderRadius: "10px",
            p: 1.25,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <Box
            component="img"
            src="/images/profile-v2/headset.svg"
            alt=""
            sx={{ width: 20, height: 20 }}
          />
        </Box>
        <Text sx={{ fontWeight: 500, fontSize: "14px", color: "#111827" }}>
          Service Relationship Manager
        </Text>
      </Stack>

      <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <Box
          component="button"
          type="button"
          onClick={onContactClick}
          sx={{
            border: 0,
            borderRadius: "12px",
            backgroundImage:
              "linear-gradient(-15.3deg, #1D4ED8 0%, #2563EB 100%)",
            boxShadow: "0px 8px 8px rgba(29,78,216,0.2)",
            width: { xs: "100%", sm: 260 },
            maxWidth: 260,
            p: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            "&:hover": { filter: "brightness(1.05)" },
          }}
        >
          <Text sx={{ fontWeight: 600, fontSize: "14px", color: "#fff" }}>
            Contact Service RM
          </Text>
        </Box>
      </Box>
    </Stack>
  </Box>
);

export default ContactServiceCard;
